import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const audius: MusicService = {
  id: 'audius',
  name: 'Audius',
  shortName: 'Audius',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#7e1bcc',
    label: '#7e1bcc',
    background: '#2f203e',
  },
  importerID: ImporterID.Audius,
  musicAPIID: MusicAPIIntegrationID.Audius,
  linkType: 'audius',
  limits: {
    matchingTracks: 10,
    addingTracks: 20,
    matchingAlbums: 10,
    addingAlbums: 20,
    matchingArtists: 10,
    addingArtists: 20,
  },
  assets: {
    logo: { light: 'audius-light.svg', dark: 'audius-dark.svg' },
    logoPadding: { light: 'audius-light-padding.svg', dark: 'audius-dark-padding.svg' },
    logoColor: { light: 'audius-color-light.svg', dark: 'audius-color-dark.svg' },
    logoColorPadding: {
      light: 'audius-color-light-padding.svg',
      dark: 'audius-color-dark-padding.svg',
    },
    logoOnBackground: 'audius-dark.svg',
  },
  whatIsDescription: musicServiceMessages.audiusWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: false,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: true,
    doesSupportFetchingLibraryAlbums: false,
    doesSupportFetchingAlbums: false,
    doesSupportFetchingAlbumTracks: false,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: true,
    doesSupportFetchingLibraryArtists: false,
    doesSupportFetchingArtists: false,
    doesSupportAddingArtistsToLibrary: false,
    doesSupportRemovingArtistsFromLibrary: false,
    doesSupportSearchByISRC: false,
    doesReturnISRC: false,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: true,
    doesReturnUserCountry: true,
    maxLimit: 50,
  },
};
